if (!customElements.get('sm-deferred-app')) {
  customElements.define('sm-deferred-app', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.template = this.querySelector('template');
      this.target = this.querySelector('[data-sm-app-content]');
      this.pending = this.querySelector('[data-sm-loading]');
      this.error = this.querySelector('[data-sm-error]');
      if (!this.template || !this.target) return;
      if (this.getAttribute('mode') === 'assessment') {
        this.details = this.closest('details');
        this.onToggle = () => { if (this.details.open) this.load(); };
        this.followHash = event => {
          const hash = event?.detail?.hash || window.location.hash;
          if (hash === '#repair-assessment-form') {
            this.details.open = true;
            this.load();
          }
        };
        this.details.addEventListener('toggle', this.onToggle);
        window.addEventListener('hashchange', this.followHash);
        document.addEventListener('hashchange:simulate', this.followHash);
        this.followHash();
        this.onToggle();
      } else if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) this.load();
        }, {rootMargin: '400px 0px'});
        this.observer.observe(this);
      } else {
        this.load();
      }
    }

    async load() {
      if (this.started) return;
      this.started = true;
      this.observer?.disconnect();
      this.setAttribute('aria-busy', 'true');
      try {
        const fragment = document.importNode(this.template.content, true);
        const scripts = Array.from(fragment.querySelectorAll('script')).filter(script =>
          !script.type || ['text/javascript', 'application/javascript', 'module'].includes(script.type));
        scripts.forEach(script => script.remove());
        this.target.appendChild(fragment);
        const ready = () => {
          const selector = this.getAttribute('ready-selector');
          if (!selector || this.target.querySelector(selector)) {
            this.pending.hidden = true;
            this.error.hidden = true;
            this.setAttribute('aria-busy', 'false');
            this.dataset.ready = 'true';
            this.readyObserver?.disconnect();
            clearTimeout(this.deadline);
            return true;
          }
          return false;
        };
        this.readyObserver = new MutationObserver(ready);
        this.readyObserver.observe(this.target, {childList: true, subtree: true});
        this.deadline = setTimeout(() => {
          if (!ready()) {
            this.pending.hidden = true;
            this.error.hidden = false;
            this.setAttribute('aria-busy', 'false');
          }
        }, 20000);
        for (const original of scripts) {
          const script = document.createElement('script');
          for (const attribute of original.attributes) {
            if (/^[a-zA-Z_:][a-zA-Z0-9_.:-]*$/.test(attribute.name)) {
              script.setAttribute(attribute.name, attribute.value);
            }
          }
          script.textContent = original.textContent;
          if (original.src) {
            script.async = false;
            await new Promise((resolve, reject) => {
              script.onload = resolve;
              script.onerror = reject;
              this.target.appendChild(script);
            });
          } else {
            this.target.appendChild(script);
          }
        }
        ready();
      } catch {
        clearTimeout(this.deadline);
        this.pending.hidden = true;
        this.error.hidden = false;
        this.setAttribute('aria-busy', 'false');
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.readyObserver?.disconnect();
      clearTimeout(this.deadline);
      this.details?.removeEventListener('toggle', this.onToggle);
      if (this.followHash) {
        window.removeEventListener('hashchange', this.followHash);
        document.removeEventListener('hashchange:simulate', this.followHash);
      }
    }
  });
}
